import { Component, Host, h } from "@stencil/core";

@Component({
  tag: "av-captcha-disclaimer",
  styleUrl: "captcha-disclaimer.scss",
  shadow: true,
})
export class CaptchaDisclaimer {
  render() {
    return (
      <Host>
        <span>This site is protected by reCAPTCHA and the Google </span>
        <a target="_blank" href="https://policies.google.com/privacy">
          Privacy Policy
        </a>{" "}
        <span>and </span>
        <a target="_blank" href="https://policies.google.com/terms">
          Terms of Service
        </a>{" "}
        <span>apply.</span>
      </Host>
    );
  }
}
